import { AfterContentInit, AfterViewInit, Component, OnInit, Output, Input, EventEmitter, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import {DomSanitizer} from "@angular/platform-browser";
// import PlaceResult = google.maps.places.PlaceResult;

import { LocationFacebookTokenPair, ReviewTargetModel } from '@models/index';
import * as gmb from '@reducers/gmb/gmb.reducer';
import {ReviewTargetSource} from '@enums/reviewTargetSource.enum'

import {environment} from '@environments/environment'

@Component({
  selector: 'app-review-target-location-form',
  templateUrl: './review-target-location-form.component.html',
  styleUrls: ['./review-target-location-form.component.sass']
})
export class ReviewTargetLocationFormComponent implements OnInit, AfterViewInit {
  suffixWidth: string = null;

  
  extVariables= {
    environment : environment
  }

  /** GOOGLE / google / Google sign in / business listings */

  @Input() reviewSources: ReviewTargetModel[];
  @Input() triggeredFrom: string;
  /**@param reviewSourceToEdit will only be used to edit, 
   * if the form is triggered form an addition then this 
   * parameter won't be taken into account */
  @Input() reviewSourceToEdit: ReviewTargetModel;
  @Input() initialReviewSource: string | null;
  _initialReviewSource: string | null;
  @Input() error:  any | null;
  @Output() searchQuery = new EventEmitter<string>();
  @Output() addReviewSource = new EventEmitter<ReviewTargetModel>();
  @Output() editReviewSource = new EventEmitter<ReviewTargetModel>();

  @Input() googleMyBusinessListings: gmb.GoogleBusiness[] | gmb.NotAuthenticated | gmb.NotFetched;
  @Input() facebookPages: LocationFacebookTokenPair[] | null;
  @Output() loginToFacebook = new EventEmitter();

  @Output() loginToGoogle = new EventEmitter();
  @Output() refreshGoogleMyBusinessListings = new EventEmitter();

  googleSignIn() { this.loginToGoogle.emit() }
  get isGoogleSignedIn(): boolean {
    // if NotFetched, then we don't know if we are signed in anyway (successful fetch indicates that)
    return Array.isArray(this.googleMyBusinessListings);
  }
  selectedGoogleLocationId: string | null = null
  selectGoogleLocationId(id: string) {
    if (this.selectedGoogleLocationId == id) {
      this.selectedGoogleLocationId = null
    } else {
      this.selectedGoogleLocationId = id

      const listing = (this.googleMyBusinessListings as gmb.GoogleBusiness[]).filter(b => b.id == id)[0]
      this.addGooglePlaceId({
        place_id: listing.placeId
      });
      
      this.reviewTargetLocationForm.patchValue({ googleBusinessId: id, source: ReviewTargetSource.googleMyBusiness });
    }
  }

  public zoom: number;
  public latitude: number;
  public longitude: number;
  // public selectedAddress: PlaceResult;

  reviewSource: ReviewTargetModel;
  selectedReviewTarget: ReviewTargetModel;
  reviewTargetInfo: string = '';
  selectedFacebookPageId: string | null = null;

  reviewTargetLocationForm: FormGroup;

  color: string;

  constructor(
    private fb: FormBuilder,
    private sanitizer:DomSanitizer,
    private ngZone: NgZone
  ) {
  }

  ngOnInit() {

    this._initialReviewSource = this.initialReviewSource;

    this.reviewTargetLocationForm = this.fb.group({
      priority: null,
      name: [null,[this.ValidateName]],
      prefix: null,
      id: null,
      logo: null,
      url: [null, [Validators.required,this.ValidateUrl]],
      callActionUrl: [null, [this.ValidateCallActionUrl]],
      googleBusinessId: null,
      enable: false,
      custom: false,
      popular: false,
      checkUsOut: false,
      color: null,
      wysiwyg: null,
      createdDate: null,
      updateDate: null,
      deleteDate: null,
      source: null,
      isReviewTarget: null,
      integrationId: null
    }
    );

    this.formChanged();
    
    this.selectedReviewTarget = this.triggeredFrom == 'edition' ? 
      this.reviewSourceToEdit : 
      this.selectedReviewTarget;
    if(this.triggeredFrom == 'edition') this.selectedReviewSource(this.selectedReviewTarget)

  }

  ngAfterViewInit() {
    if (this._initialReviewSource && this.triggeredFrom == 'add') {
      this.searchQuery.emit(this._initialReviewSource);

      (async () => {
        // wait until the review sources for the searchQuery have loaded
        await new Promise<void>((resolve) => setTimeout(() =>
          (Array.isArray(this.reviewSources) && this.reviewSources.length > 0 && resolve()),
        800));

        // selected the requested initialReviewSource by exact "name" match
        this.selectedReviewSource(this.reviewSources.find(x => x.name == this._initialReviewSource));
        // reset initialReviewSource after a reasonable timeout
        this._initialReviewSource = null;
      })();
    }

  }


  formChanged(): void {
    this.reviewTargetLocationForm.valueChanges.subscribe(
      val => {
        this.suffixWidth = val.url ? ((val.url.length + 1) * 8) + 'px' : null
      }
    )
  }

  queryChange(event) {
    this.searchQuery.emit(event.query)
    this.reviewTargetInfo = ''
    this.reviewTargetLocationForm.patchValue({
      name: null
    })
  }

  selectedReviewSource(selected){
    this.selectedReviewTarget = selected;
    this.reviewTargetInfo = selected.wysiwyg;
    this.reviewTargetLocationForm.patchValue({
      priority: selected.priority,
      name: selected.name,
      prefix: selected.prefix,
      id: selected.id,
      logo: selected.logo,
      url: selected.url,
      callActionUrl: selected.callActionUrl,
      enable: selected.enable,
      custom: selected.custom,
      popular: selected.popular,
      checkUsOut: selected.checkUsOut,
      color: selected.color,
      wysiwyg: selected.wysiwyg,
      createdDate: selected.createdDate,
      updateDate: selected.updateDate,
      deleteDate: selected.deleteDate,
      source: selected.name ?
        this.triggeredFrom == 'edition' && selected.name.toLowerCase().includes('google')? 
        ReviewTargetSource.googleMyBusiness 
        : selected.source
        : selected.source,
      isReviewTarget: selected.isReviewTarget,
      integrationId: selected.integrationId
    })
    if(selected.name.toLowerCase().includes('google')) this.refreshGoogleMyBusinessListings.emit()
  }

  clear() {
    this.reviewTargetInfo = '';
    this.reviewTargetLocationForm.patchValue({
      priority: null,
      name: null,
      prefix: null,
      id: null,
      logo: null,
      url: null,
      callActionUrl: null,
      enable: false,
      custom: false,
      popular: false,
      checkUsOut: false,
      color: null,
      wysiwyg: null,
      createdDate: null,
      updateDate: null,
      deleteDate: null,
      googleBusinessId: null,
    })
  }

  onSubmit(){
    this.addReviewSource.emit(this.reviewTargetLocationForm.value)
  }

  onEdit(){
    this.editReviewSource.emit(this.reviewTargetLocationForm.value)
  }

  transformHtml(html: string){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  isGoogle = () => {
    return this.reviewTargetLocationForm ?
    this.reviewTargetLocationForm.value.name ? 
      this.reviewTargetLocationForm.value.name.toLowerCase().includes('google') 
      : false
    :false
  }

  isZillow = () =>{
    return this.reviewTargetLocationForm ?
    this.reviewTargetLocationForm.value.name ? 
      this.reviewTargetLocationForm.value.name.toLowerCase().includes('zillow') 
      : false
    :false
  }

  isHouzz = () =>{
    return this.reviewTargetLocationForm ?
    this.reviewTargetLocationForm.value.name ? 
      this.reviewTargetLocationForm.value.name.toLowerCase().includes('houzz') 
      : false
    : false
  }

  isGoogleBusinessArea = () => {
    return this.reviewTargetLocationForm ?
    this.reviewTargetLocationForm.value.name ? 
      this.reviewTargetLocationForm.value.name.toLowerCase().includes('google service area') && this.extVariables.environment.gmb_enabled
      : false
    :false
  }

  addGooglePlaceId(event){
    this.ngZone.run(()=> 
    this.reviewTargetLocationForm.patchValue({
      url: `/local/writereview?placeid=${event.place_id}`
    }))
  }

  ValidateUrl(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  ValidateName(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  ValidateCallActionUrl = (control: AbstractControl) => {
    if((control.value && (control.value.trim().length && this.isZillow && this.isHouzz)
      || (!control.value && !this.isZillow() && !this.isHouzz()))){
        
      return null;
    }
    return {invalid: true};
  }

  isFacebook = () => {
    return this.reviewTargetLocationForm ?
    this.reviewTargetLocationForm.value.name ? 
      this.reviewTargetLocationForm.value.name.toLowerCase().includes('facebook') 
      : false
    :false
  }

  showContinueWthFacebookButton(){
    this.facebookPages 
      ? this.facebookPages.some(page=>page.token.authFailure || page.token.permissionFailure)
      : false
  }
  
  selectFacebookPageId(locationFacebookTokenPair: LocationFacebookTokenPair) {
    if (this.selectedFacebookPageId == locationFacebookTokenPair.token.pageId) {
      this.selectedFacebookPageId = null
    } else {
      this.selectedFacebookPageId = locationFacebookTokenPair.token.pageId
      
      this.ngZone.run(()=> 
      this.reviewTargetLocationForm.patchValue({
        url: this.facebookPages.some(page=> page.token.pageId == locationFacebookTokenPair.token.pageId)
          ? this.facebookPages.filter(page=> page.token.pageId == locationFacebookTokenPair.token.pageId)[0].token.pageId
          : '',
        source: ReviewTargetSource.facebook,
        integrationId: this.facebookPages.some(page=> page.token.pageId == locationFacebookTokenPair.token.pageId)
          ? this.facebookPages.filter(page=> page.token.pageId == locationFacebookTokenPair.token.pageId)[0].token.pageId
          : ''
      }))
    }
  }

}
